// extracted by mini-css-extract-plugin
export default {"wrapper":"Alert_wrapper__h6x+N","error":"Alert_error__hSm7C","success":"Alert_success__pvk9G","alert":"Alert_alert__1X9nI","alert__text":"Alert_alert__text__nsrVX"};